import { customDispatch } from "@affinity/Store/ServiceBase";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getBillTo, updateBillTo, UpdateBillToApiParameter } from "@insite/client-framework/Services/CustomersService";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";

// External parameters
interface PlaceOrderSetDeliveryInstructionsParameters {
    deliveryInstructions: string,
    phone: string | undefined,
    billToId: string,
}

// Internal parameters
interface Props {
    deliveryInstructions: string,
    phone: string,
    billTo: BillToModel,
    billToResult: BillToModel, // For debugging purposes
}

type HandlerType = Handler<PlaceOrderSetDeliveryInstructionsParameters, Props>;

const UpdateContactDetails: HandlerType = async props => {
    if (!props.parameter.phone) {
        // Should reach here if number has not changed
        return;
    }

    // Should reach here if number added for the first time or updated
    if (props.parameter.billToId) {
        props.billTo = await getBillTo({ billToId: props.parameter.billToId })
    }

    if (props.billTo) {
        const updatedBillTo: BillToModel = {
            ...props.billTo,
            phone: props.parameter.phone ?? '',
        };
        const billToApiParameter: UpdateBillToApiParameter = {
            billTo: updatedBillTo
        }
        props.billToResult = await updateBillTo(billToApiParameter);
    }
}

const UpdateState: HandlerType = props => {
    (props.dispatch as customDispatch)({
        type: "Affinity/DeliveryInstructions/Set",
        phone: props.parameter.phone,
        deliveryInstructions: props.parameter.deliveryInstructions,
    });
}

const Tracking: HandlerType = props => {
    //
}

const chain = [
    // UpdateContactDetails,
    UpdateState,
    Tracking,
];

const PlaceOrderSetDeliveryInstructions = createHandlerChainRunner(chain, "PlaceOrderSetDeliveryInstructions");
export default PlaceOrderSetDeliveryInstructions;